import { render, staticRenderFns } from "./OrderConcepts.vue?vue&type=template&id=3929f9dd&"
import script from "./OrderConcepts.vue?vue&type=script&lang=js&"
export * from "./OrderConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports